import Vue from "vue";
import VueRouter from "vue-router";
import {
	MessageBox
} from 'element-ui'
import store from './../store'
Vue.use(VueRouter);

const routes = [{
		path: "/",
		redirect: "/index"
	},
	{
		path: "/login",
		name: "Login",
		meta: {
			title: '登录注册'
		},
		component: () => import("@/views/login.vue")
	},
	{
		path: "/oneseif",
		name: "OneseIf",
		meta: {
			title: '个人中心'
		},
		component: () => import("@/views/oneseif/index.vue")
	},
	{
		path: "/uploading",
		name: "Uploading",
		meta: {
			title: '上传文档'
		},
		component: () => import("@/views/uploading/index.vue")
	},
	{ //文章详情
		path: "/article_details",
		name: "ArticleDetails",
		meta: {
			title: '文章详情'
		},
		component: () => import("@/views/details/article/index.vue")
	},
	{ //视频详情
		path: "/video_details",
		name: "VideoDetails",
		meta: {
			title: '视频详情'
		},
		component: () => import("@/views/details/video/index.vue")
	},
	{ //首页
		path: "/index",
		name: "Index",
		meta: {
			title: '首页'
		},
		component: () => import("@/views/index/index.vue")
	},
	{
		path: "/news",
		name: "News",
		meta: {
			title: '新闻中心'
		},
		component: () => import("@/views/article_list/index.vue")
	},
	{
		path: "/product",
		name: "Product",
		meta: {
			title: '产品中心'
		},
		component: () => import("@/views/article_list/index4.vue")
	},
	{
		path: "/honor",
		name: "Honor",
		meta: {
			title: '荣誉资质'
		},
		component: () => import("@/views/honor/index.vue")
	},
	{
		path: "/party",
		name: "Party",
		meta: {
			title: '鸿科党建'
		},
		component: () => import("@/views/article_list/index.vue")
	},
	{
		path: "/about",
		name: "About",
		meta: {
			title: '关于鸿科'
		},
		component: () => import("@/views/about/index.vue")
	},
	{
		path: "/culture",
		name: "Culture",
		meta: {
			title: '企业文化'
		},
		component: () => import("@/views/article_list/index.vue")
	},
	// { //鸿科文化
	//   path: "/about",
	//   name: "About",
	//   meta: {
	//     title: '鸿科文化'
	//   },
	//   component: () => import("@/views/article_list/index.vue")
	// },
	{ //文章分类
		path: "/thematic_list",
		name: "ThematicList",
		meta: {
			title: '文章分类'
		},
		component: () => import("@/views/thematic_list/index.vue")
	},
	{ //教学视频
		path: "/video_list",
		name: "VideoList",
		meta: {
			title: '教学视频'
		},
		component: () => import("@/views/video_list/index.vue")
	},
	{ //问答社区
		path: "/article_list1",
		name: "ArticleList1",
		meta: {
			title: '员工社区'
		},
		component: () => import("@/views/article_list/index2.vue")
	},
	{ //快讯
		path: "/article_list2",
		name: "ArticleList2",
		meta: {
			title: '快讯'
		},
		component: () => import("@/views/article_list/index.vue")
	},
	{ //生产报表
		path: "/article_list3",
		name: "ArticleList3",
		meta: {
			title: '生产报表'
		},
		component: () => import("@/views/article_list/index2.vue")
	},
	{ //收藏
		path: "/collect",
		name: "Collect",
		meta: {
			title: '收藏'
		},
		component: () => import("@/views/collect/index.vue")
	},
	{ //搜索页
		path: "/search",
		name: "search",
		meta: {
			title: '搜索'
		},
		component: () => import("@/views/collect/index.vue")
	},
	{ //测算
		path: "/calculate",
		name: "calculate",
		meta: {
			title: '搜索'
		},
		component: () => import("@/views/calculate/index.vue")
	},
	{ // 模板一
		path: "/thematic_list/template_1",
		name:'templateOne',
		component: () => import("@/views/article_list/index.vue")
	},
	{ // 模板二
		path: "/thematic_list/template_2",
		component: () => import("@/views/article_list/index2.vue")
	},
	{ // 模板三
		path: "/thematic_list/template_3",
		component: () => import("@/views/article_list/index3.vue")
	},
	{ // 模板一
		path: "/video_list/video_1",
		component: () => import("@/views/article_list/index.vue")
	},
	{ // 模板二
		path: "/video_list/video_2",
		component: () => import("@/views/article_list/index2.vue")
	},
	{ // 模板三
		path: "/video_list/video_3",
		component: () => import("@/views/article_list/index3.vue")
	},
	{
		path: '/404',
		component: () => import('@/views/404'),
		hidden: true
	},
	{
		path: '*',
		redirect: '/404',
		hidden: true
	}
];


const router = new VueRouter({
	mode: "history",
	base: process.env.BASE_URL,
	routes
});

router.beforeEach((to, from, next) => {
	if (to.path == '/article_list3') {
		if (store.state.info.userLevel == 12 || store.state.info.userLevel == 123 || store.state.info
			.userLevel === undefined) {
			next()
		} else {
			MessageBox('暂无访问权限，请联系管理员！', '提示')
		}
	} else if (to.path == '/calculate') {
		if (store.state.info.userLevel == 13 || store.state.info.userLevel == 123 || store.state.info
			.userLevel === undefined) {
			next()
		} else {
			MessageBox('暂无访问权限，请联系管理员！', '提示')
		}
	} else {
		next()
	}
})

export default router;
